module.exports = __webpack_public_path__ + "img/Chilli.e0bb2cce.svg";